module.exports = __webpack_public_path__ + "img/eight6Green.9c7353d2.jpg";